<div class="overlay">
    <div class="message">Processing...</div>
</div>